import LandingPageFeatures from '@/app/components/LandingPage/LandingPageFeatures';

import sleepAndRestFeatures from './data/sleepAndRestFeatures';
import sleepAndRestFeaturesGradients from './data/sleepAndRestFeaturesGradients';

const SleepAndRestFeatures = () => {
  return (
    <section data-cy="sleep-and-rest-features">
      <LandingPageFeatures
        eyebrow="sleep_and_rest_features_eyebrow"
        features={sleepAndRestFeatures}
        theme="light"
        imageGradientBg={{
          className: 'bg-slate-600',
          gradients: sleepAndRestFeaturesGradients,
        }}
        textColor="sandstone-200"
      />
    </section>
  );
};

export default SleepAndRestFeatures;
